import { Button, FlexBox, Modal, Typography } from "@joonapp/web-shared"
import { create } from "zustand"

import { sessionManager } from "../../util/storage"

interface FreeTrialFirstVerifyModalStore {
  isOpen: boolean
  onOpen: () => void
  onClose: () => void
}

export const useFreeTrialFirstVerifyModalStore =
  create<FreeTrialFirstVerifyModalStore>((set) => ({
    isOpen: false,
    onOpen: () => set({ isOpen: true }),
    onClose: () => {
      sessionManager.clearNeedsToSeeVerifyFreemiumPopup()
      set({ isOpen: false })
    },
  }))

const FreeTrialFirstVerifyModal = () => {
  const { isOpen, onClose } = useFreeTrialFirstVerifyModalStore()

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      displayCloseIcon
      animate
      style={{ width: "min(400px, 95vw)" }}
    >
      <FlexBox direction="column">
        <Typography variant="bodyBold" textAlign="left" className="px-6 py-4">
          Review quests and give bonus rewards for a job well done in one tap!
        </Typography>
        <img
          src="/images/free_trial_first_verify.png"
          alt="Free trial first verify"
          style={{ width: "100%" }}
        />
        <div className="w-full flex flex-col gap-4 p-6 pt-4 text-center">
          <Typography variant="body" textAlign="left">
            You can approve up to 7 Quests a day without a subscription!
          </Typography>
          <Button text="Got it!" onClick={onClose} fullWidth />
        </div>
      </FlexBox>
    </Modal>
  )
}

export default FreeTrialFirstVerifyModal
